import LocalStorage from '../local-storage/LocalStorage'

const LABEL_FORMAT_KEY = 'label.format'

const LabelFormatStorage = {
  get: (): string | undefined => LocalStorage.get<string>(LABEL_FORMAT_KEY),
  set: (format: string): void => LocalStorage.set(LABEL_FORMAT_KEY, format),
  clear: (): void => LocalStorage.remove(LABEL_FORMAT_KEY),
}

export default LabelFormatStorage
